import { render } from "./Index.vue?vue&type=template&id=34f18fbc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=34f18fbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f18fbc"],['__file',"components/Vendors/Funds/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34f18fbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34f18fbc', __exports__)) {
    api.reload('34f18fbc', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=34f18fbc&scoped=true", () => {
    api.rerender('34f18fbc', render)
  })

}


export default __exports__